import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import ReplaceContact from '../Replace/ReplaceContact/ReplaceContact.js';
import ReportProblemIcon from '@material-ui/icons/ReportProblemOutlined';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import {
  getString,
  iPhoneFriendlyButtonLabel,
} from '../../helpers/stringHelpers.js';

const stringsComponent = 'invalidBankDialog';

class InvalidBankDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
    };

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleUpdate() {
    this.setState({ open: false });

    window.location.href = '/#/profile/Account-Details';
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    const { classes, toggleContactModal } = this.props;
    const { open } = this.state;

    const showDialog = open && window.location.href.includes('/#/dash');

    return (
      <div>
        <Dialog open={showDialog}>
          <DialogTitle className={classes.title}>
            <ReportProblemIcon style={{ color: '#007749' }} />
            <Typography variant="h3" className={classes.title}>
              {getString(stringsComponent, 'TITLE')}
            </Typography>
          </DialogTitle>
          <br />
          <DialogContent>
            <Typography component="div" variant="body1">
              {getString(stringsComponent, 'CONTENT_PART1')}{' '}
              <a href="#" onClick={this.handleUpdate} className={classes.link}>
                {getString(stringsComponent, 'BANK_DETAILS_LINK_LABEL')}
              </a>{' '}
              <ReplaceContact
                content={getString(stringsComponent, 'CONTENT_PART2')}
                action={toggleContactModal}
                isLink={true}
              />
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button variant="outlined" onClick={this.handleClose}>
              {getString(stringsComponent, 'CLOSE_LABEL')}
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={this.handleUpdate}
            >
              {getString(stringsComponent, 'UPDATE_LABEL')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(InvalidBankDialog);
